import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "../sharedComponents";

const Login = lazy(() => import("../pages/Authentication/Login"));
const Register = lazy(() =>
  import("../pages/Authentication/Register/Register")
);


export const publicRoutes = [
  {
    path: "/giris",
    component: (
      <Suspense fallback={<Loading />}>
        <Login />
      </Suspense>
    ),
    claim: "",
  },
  {
    path: "/kayit",
    component: (
      <Suspense fallback={<Loading />}>
        <Register />
      </Suspense>
    ),
    claim: "",
  },
  
  {
    path: "*",
    component: <Navigate to={"/"} />,
    claim: "",
  },
];
